import { DateInput, Field, NumericInput, TextInput, TextOutput, TimeInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { DateTimeStyle } from 'Components/Layout/Grid/types';
import { WorksheetBalanceFieldSet, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { getDryMassGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/BsEn/gridFieldSets';
import { DateTimeDataFormat } from 'Lib/Format';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';

let ConstantDryMassDeterminationMultiTraySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const showTimeInOven = useSelector(
    pipe(createDryMassEntryOptionSelector(createWorksheetSelector!), (v) => v !== 'Never')
  );

  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  return (
    <>
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.DryMassBalance" />
      </ListFieldSection>
      <WorksheetGridFieldSection name="DryingTrays">
        <WorksheetRecordGrid
          name="DryingTrays"
          orientation="horizontal"
          scrollLinkId="mddCompaction"
          rowHeaderWidth={200}
          recordProps={{
            width: 130,
            enforceAtLeastOneRecord: true,
            removeConfirm: {
              confirm: true,
              confirmTitle: 'Delete drying tray',
              confirmText: 'Are you sure you want to delete the drying tray? Data cannot be recovered.',
              confirmButtonText: 'Delete',
            },
          }}
          fieldSet={[
            { name: 'ContainerLabel', component: <Field input={<TextInput />} /> }, //maxLength:20
            { name: 'ContainerMass', component: <Field input={<NumericInput />} /> },
            {
              name: 'DateTimePlacedInOvenLocal',
              component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
              label: 'Date in Oven',
              hidden: !showTimeInOven,
            },
            {
              name: 'DateTimePlacedInOvenLocal',
              component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
              label: 'Time in Oven',
              hidden: !showTimeInOven,
            },
            {
              name: 'DryMassReadings',
              recordProps: (i: number) => ({
                enforceAtLeastOneRecord: true,
                preventRemove: 'all-but-last',
                preventCreate: dryMassEntryOption === 'Never',
                removeConfirm: {
                  confirm: true,
                  confirmTitle: 'Delete Dry Mass Reading',
                  confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
                  confirmButtonText: 'Delete',
                },
              }),
              fields: [...getDryMassGridFieldSet(dryMassEntryOption, DateTimeStyle.Separate)],
            },
            {
              name: 'ConstantDrySoilMass',
              component: <Field input={<TextOutput />} />,
            },
          ]}
        />
      </WorksheetGridFieldSection>
    </>
  );
};

ConstantDryMassDeterminationMultiTraySection = withInjectedProps(ConstantDryMassDeterminationMultiTraySection);

export { ConstantDryMassDeterminationMultiTraySection };
export default ConstantDryMassDeterminationMultiTraySection;
